import React from "react";
import styled from "styled-components";
import { cloud, ninja, ocean } from "@vitalsource/vstui/colors";

const FacultyDialogContainer = styled.div`
  margin: -20px -24px 0 -24px;
`;

const FacultyDialogInnerTop = styled.div`
  background-color: ${cloud.getShade(3)};
  padding: 24px 24px;
  #upload-tos {
    font-style: italic;
  }
`;

const FacultyDialogInnerBottom = styled.div`
  color: ${ninja.getShade(10)};
  font-size: 1.6rem;
  padding: 25px 24px 0;
  #sales-pitch {
    margin-bottom: 20px;
  }
  .bold {
    font-weight: 700;
  }
`;

export default () => {
  return (
    <FacultyDialogContainer>
      <FacultyDialogInnerTop>
        <p id="upload-tos">{i18n.t("main-menu.faculty.upload-tos")}</p>
      </FacultyDialogInnerTop>
      <FacultyDialogInnerBottom>
        <p id="sales-pitch">{i18n.t("main-menu.faculty.sales-pitch")}</p>
        <p id="process">
          {i18n.t("main-menu.faculty.process")}
          <span className="bold">
            {i18n.t("main-menu.faculty.required-info")}
          </span>
        </p>
      </FacultyDialogInnerBottom>
    </FacultyDialogContainer>
  );
};
